import { WidgetEventStruct } from "../../widget-event.struct";
import { AlertWidgetEnum } from "../../../enums";

export class AlertWidgetEventStruct extends WidgetEventStruct {
  public event_alert_widget_type: AlertWidgetEnum;
}
